import { render, staticRenderFns } from "./WPickups.vue?vue&type=template&id=ca3c2654&scoped=true&"
import script from "./WPickups.vue?vue&type=script&lang=js&"
export * from "./WPickups.vue?vue&type=script&lang=js&"
import style0 from "./WPickups.vue?vue&type=style&index=0&id=ca3c2654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3c2654",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WDiscountsDetail from '@/components/WDiscountsDetail.vue'
import WItemVariant from '@/components/WItemVariant.vue'
import WOrderPaymentDetails from '@/components/WOrderPaymentDetails.vue'
import WShipmentCustomValues from '@/components/WShipmentCustomValues.vue'
autoInstallComponents(component, {WDiscountsDetail,WItemVariant,WOrderPaymentDetails,WShipmentCustomValues})
